module.exports = __webpack_public_path__ + "static/media/project3.6d740a8d.png";